import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

export const ContainerFooter = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  z-index: ${BaSeTheme.stackOrder.normal};

  ${({ isAuthenticated }) =>
    isAuthenticated &&
    css`
      bottom: 0px;
    `}
`;

export const FooterWrapper = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  text-align: center;
  bottom: 0px;
  width: 100%;
  ${({ isAuthenticated }) =>
    isAuthenticated
      ? css`
          height: 42px;
          background-color: ${BaSeTheme.colors.defaultColors.white};
          position: absolute;
        `
      : css`
          height: 100px;
          background-color: ${BaSeTheme.colors.institucionais.cinzaSebrae10};
          position: absolute;
        `}
`;

export const FooterMenu = styled.ul`
  list-style: none;
  display: inline-flex;

  li:last-child {
    border-right: none;
  }
`;

export const MenuItem = styled.li`
  padding: 5px 16px 5px 16px;
  border-right: 1px solid rgba(255, 255, 255, 0.2);

  a {
    text-decoration: none;
  }
`;

export const FooterLine = styled.hr`
  position: absolute;
  left: 0;
  right: 0;
  border: none;
  background-color: ${BaSeTheme.colors.institucionais.cinzaSebrae90};
  opacity: 0.5;
  ${({ isAuthenticated }) =>
    isAuthenticated
      ? css`
          border: 1px solid ${BaSeTheme.colors.institucionais.cinzaSebrae90};
          margin: 0;
          top: 0;
        `
      : css`
          height: 1px;
        `}
`;

export const FooterLoggedUser = styled.div`
  width: 100vw;
  max-width: ${BaSeTheme.breakpoints.desktop.minWidth}px;
  display: flex;
`;

export const ColumnOne = styled.div`
  width: 60%;
  text-align: end;
`;

export const ColumnTwo = styled.div`
  width: 40%;
  text-align: end;
`;
